import type { SectionSettings } from "@gatsby-plugin-generic-page/fragments/sectionSettings"
import getSectionOnColor from "./getSectionOnColor"

const DARK_ON_COLORS = ["backgroundDarker", "customDark"]

/**
 * Whether the section's content sits on a dark background (an inverted UDS
 * surface, or a custom color with light text), so it needs light text.
 */
export default function isDarkSectionBackground(
  sectionSettings: Pick<SectionSettings, "customColor"> | undefined
): boolean {
  return DARK_ON_COLORS.includes(getSectionOnColor(sectionSettings))
}
